export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/hoodies.b5b2d39.svg";